/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
import {Link} from "react-router-dom";
import React from "react";

export const ModifySearchHeader = ({ modifySearchUrl }) => {
  const { ChevronLeft } = require("@carbon/react/icons");

  const linkURL_encoded = encodeURI(modifySearchUrl);
  const modifySearchLinkContent = (
    <>
      <ChevronLeft />
      <span className="modify-link-text">Modify Search</span>
    </>
  );

  return (
      <div data-testid="modify-search-link" className="neofax-enteral-info-header">
        <Link className="neofax-enteral-modify-link" key="a" to={linkURL_encoded}>
          {modifySearchLinkContent}
        </Link>
      </div>
  );
};
